/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import { Color, ID } from "src/libs/interfaces/layouts"
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import { __ } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingFloat, ILandingPrimitive, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import useSelectedContent from "src/modules/pe-landing-module/hooks/useSelectedContent"
import updateSection from "../utils/updateSection"
import { Icon, Tag } from "@blueprintjs/core"

/* Protopia Ecosystem component */
export interface IFillPanelProps {
   
}
const FillPanel = (props: IFillPanelProps): JSX.Element => {
    const color                     = useLandingConsoleStore((state: ILandingConsoleStore) => state.color)
    const currentLanding: ILanding  = useLandingStore((state: ILandingStore) => state.currentLanding)
    const selectedLayer : ID        = useLandingStore((state: ILandingStore) => state.selectedLayer)
    const selectedData              = useSelectedContent()

    const getColor = (): Color => {
        switch (selectedData.type ) {
            case SELECT_TYPE.CONTENT:
                return ""
            case SELECT_TYPE.FLOAT: 
                const primitives: ILandingPrimitive[]   = selectedData.data?.primitives || [] 
                if(!!primitives[0]) {
                    if(!!primitives[0].fill) {
                        return primitives[0].fill || ""
                    }
                }
                else if(!!primitives[1]) {
                    return primitives[1].fill || ""
                } 
                return "" 
            case SELECT_TYPE.TITLE:
                if(selectedData.data?.color) {
                    return selectedData.data.color
                }
                return currentLanding.title?.color || ""
            case SELECT_TYPE.NONE:
            default:
                return color
        }
    }

    useEffect(() => {
        getColor()
    }, [ selectedData ])
    
    const onColor = ( color: Color ) => {
        let step:IHistoryStep = {
            type: HISTORY_TYPE.SECTION,
            data: null,
            prevData: null,
            title: ""
        }, id: ID

        useLandingConsoleStore.setState({ color })
        if( !selectedData.data ) {
            return color
        }
        switch (selectedData.type ) {
            case SELECT_TYPE.CONTENT:
                return color
            case SELECT_TYPE.FLOAT: 
                const primitives: ILandingPrimitive[]   = selectedData.data.primitives || [] 
                id = selectedData.data.id 
                step.prevData = JSON.parse(JSON.stringify(currentLanding.sections.find(section => section.id === selectedLayer) || {}))
                step.data = {
                    ...step.prevData,
                    floats: step.prevData.floats?.map((float: ILandingFloat) => {
                        if(float.id === id ) {
                            return {
                                ...float,
                                primitives: primitives.map((primitive: ILandingPrimitive) => {
                                    return {
                                        ...primitive,
                                        fill: color
                                    }
                                }) 
                            }
                        }
                        return float
                    }) 
                }
                step.title = "Fill Float"
                updateSection(step.data, step) 
                return color 
            case SELECT_TYPE.TITLE:
                id = selectedData.data.id 
                step.prevData = JSON.parse(JSON.stringify(currentLanding.sections.find(section => section.id === selectedLayer) || {}))
                step.data = {
                    ...step.prevData,
                    title: {
                        ...step.prevData.title,
                        color: color
                    }
                }
                step.title = "Fill Selection title" 
                updateSection(step.data, step) 
                return color
            case SELECT_TYPE.NONE:
            default:
                if( color !== "transparent") {
                    useLandingConsoleStore.setState({ color })
                }
                return color
        }
        
    }
    const onClear = () => {
        onColor("transparent")
    }
    const onEyeDrop = () => {
        // https://stackoverflow.com/questions/1936021/javascript-eyedropper-tell-color-of-pixel-under-mouse-cursor
        // https://developer.mozilla.org/en-US/docs/Web/API/EyeDropper_API
        // https://dev.to/atapas/how-to-create-an-eyedropper-tool-using-javascript-3k59

        if('EyeDropper' in window) {
            const eyeDropper = new window.EyeDropper()
            eyeDropper
                .open()
                .then((result: any) => {
                        const color = result.sRGBHex
                        onColor( color )
                    })
                    .catch( (e: any) => {
                        console.error(e)
                    })
        } else {
            console.warn('No Support: This browser does not support the EyeDropper API yet!')
        }
    }

    return <div className="landing-edit-layer"> 
        <div className="panel-list-2 overflow-y-auto pb-3"> 
            <div className="container pr-0 pl-4">
                <FieldInput
                    type={ SCALAR_TYPES.COLOR }
                    editable
                    value={ getColor() }
                    onChange={ onColor }
                    notClear
                />
            </div>
        </div>
        <div className='landing-select-layer-panel'>
            <div className="d-flex pt-1 pl-1 small w-100">
                <Tag 
                    minimal 
                    size="medium" 
                    className="small text-light py-0 px-1 mb-1 mr-1 hover pointer"
                    onClick={ onClear } 
                    style={{ height: 22 }}
                >  
                    <div className="d-flex align-items-center ">
                        <Icon icon="cross" size={ 9 } />
                        <div className="small letter-spacing-1 ml-1">
                            {__("Clear")}
                        </div>
                    </div>
                </Tag>
                {
                    ('EyeDropper' in window) && <Tag 
                        minimal 
                        size="medium" 
                        className="small text-light py-0 px-1 mb-1 mr-1 hover pointer"
                        onClick={ onEyeDrop } 
                        style={{ height: 22 }}
                    >  
                        <div className="d-flex align-items-center ">
                            <img src={`/assets/img/landing/eye-dropper.svg`} height={10} alt="" className="panel-icon" />
                            <div className="small letter-spacing-1 ml-1">
                                {__("Click chooser color")}
                            </div>
                        </div>
                    </Tag>
                }
            </div>
        </div>
    </div>
}
export default FillPanel

declare global {
    interface Window { EyeDropper: any } 
}